import { getQueryFromObject } from 'network/utils';
import { API } from 'aws-amplify';
import awsUtils from 'utils/awsUtils';
import { IHireCompanyFilters } from 'types/Filters/HireCompanyFilters';

const apiName = awsUtils.getAPIName();

const getAll = async (filters: IHireCompanyFilters = {}) => {
    const authHeader = await awsUtils.getAuthHeader();
    const query = getQueryFromObject(filters)
    const path = `/outdefine_hire/company/?${query}`;
    const myInit = {
        headers: { ...authHeader, },
    };

    const result = await API.get(apiName, path, myInit);
    return result;
};

const getOne = async (filters: IHireCompanyFilters = {}) => {
    return (await getAll(filters)).data[0];
}

const HireCompanyApi = { getAll, getOne };

export default HireCompanyApi;